const buildDefaultSelection = (formTypes = [], columnsByFormType = null) => formTypes.reduce((acc, formType) => {
  const columns = (columnsByFormType === null || columnsByFormType === void 0 ? void 0 : columnsByFormType[formType.formTypeIdentifier]) || formType.columns || [];
  acc[formType.formTypeIdentifier] = columns.map(column => column.contentPath);
  return acc;
}, {});
const buildPendingSelection = (formTypes = []) => formTypes.reduce((acc, formType) => {
  acc[formType.formTypeIdentifier] = [];
  return acc;
}, {});
export { buildPendingSelection };
export default buildDefaultSelection;